import { useEffect } from "react";
// import { signal } from "@preact/signals-react";

import funcs from "tools/functions";
import proxy from "api/proxy";

const formatter = Intl.NumberFormat("en-US");

function ProductPackage({ records, handleAdd, quantity }) {
  return (
    <div id="product-package" className="grid grid-cols-4">
      {records.map((record) => (
        <div
          key="hotel-booking-wizard-bill"
          className="flex flex-col h-20 py-3 px-6  bg-blue-100 rounded-2xl cursor-pointer active:scale-95"
          onClick={() => handleAdd(record)}
        >
          <span className="font-bold text-neutral-700">
            {record.description}
          </span>
          <div className="flex justify-between mt-1">
            <span className="justify-between">
              Precio: {formatter.format(record.unit_price)}
            </span>
            <span className="justify-between">Cant. {quantity}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProductPackage;
